import { createSlice } from "@reduxjs/toolkit";
import { apiGetHowWeDo } from "../helpers/backend_helper";

const howWeDoSlice = createSlice({
    name : 'howWeDo',
    initialState: {
        data : [],
        loading : false,
        error : null,
    },
    reducers : {
        fetchHowWeDoRequest(state){
            state.loading = true;
            state.error = null;
        },
        fetchHowWeDoSuccess(state, action){
            state.loading = false;
            state.data = action.payload;
        },
        fetchHowWeDoFailure(state, action){
            state.loading = false;
            state.data = action.payload;
        },
    },
});

export const { fetchHowWeDoRequest, fetchHowWeDoSuccess, fetchHowWeDoFailure} = howWeDoSlice.actions;

export const fetchHowWeDoData = () => async (dispatch) => {
    dispatch(fetchHowWeDoRequest());
    try{
        const response = await apiGetHowWeDo();
        dispatch(fetchHowWeDoSuccess(response.results.data));
    }
    catch(error){
        dispatch(fetchHowWeDoFailure(error.message || 'Error fetchinh the How We Do Data'));
    }
};

export default howWeDoSlice.reducer;